/** Softmax sur des logits bruts → probabilités [0, 1] sommant à 1.
 *  Utile pour rendre les barres comparables visuellement quand les logits
 *  ont des plages très différentes (positifs + négatifs).
 */
export function softmax(scores: number[]): number[] {
  if (scores.length === 0) return [];
  const max = Math.max(...scores);
  const exps = scores.map((s) => Math.exp(s - max));
  const sum = exps.reduce((acc, v) => acc + v, 0);
  return exps.map((v) => v / sum);
}
